import React, { useState, useEffect } from 'react';
import emailjs from 'emailjs-com';
import { FaFacebook, FaYoutube, FaInstagram, FaChevronDown } from "react-icons/fa";
import { FaBars,FaTimes } from 'react-icons/fa';

import logo from "../../assets/images/logo-trans.png"
import navimg from "../../assets/images/stocks-3.jpg"


function Header() {

      
// Dark to light mode js
const lightToDarkButton = document.getElementById("light--to-dark-button");
lightToDarkButton?.addEventListener("click", function () {
    if (localStorage.getItem("theme-color")) {
      if (localStorage.getItem("theme-color") === "light") {
        document.documentElement.classList.add("is_dark");
        localStorage.setItem("theme-color", "dark");
        lightToDarkButton?.classList.add("dark--mode");
      } else {
        document.documentElement.classList.remove("is_dark");
        localStorage.setItem("theme-color", "light");
        lightToDarkButton?.classList?.remove("dark--mode");
      }
    } else {
      if (document.documentElement.classList.contains("is_dark")) {
        document.documentElement.classList.remove("is_dark");
        lightToDarkButton?.classList?.remove("dark--mode");
        localStorage.setItem("theme-color", "light");
      } else {
        document.documentElement.classList.add("is_dark");
        localStorage.setItem("theme-color", "dark");
        lightToDarkButton?.classList.add("dark--mode");
      }
    }
});

 // On page load or when changing themes, best to add inline in `head` to avoid FOUC
 if (localStorage.getItem("theme-color") === "dark" || (!("theme-color" in localStorage) && window.matchMedia("(prefers-color-scheme: dark)").matches)) {
  document.documentElement.classList.add("dark--mode");
} 
if (localStorage.getItem("theme-color") === "light") {
  document.documentElement.classList.remove("dark--mode");
} 





// ***************

const [activeDropdown, setActiveDropdown] = useState(null);
    const [menuOpen, setMenuOpen] = useState(false);

    document.documentElement.classList.add("is_dark");
localStorage.setItem("theme-color", "dark");

const [isOpen, setIsOpen] = useState(false);

// Function to open the pop-up
const openPopup = () => {
  setIsOpen(true);
};

// Function to close the pop-up
const closePopup = () => {
  setIsOpen(false);
};

useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [menuOpen]);


  const [openPhase, setOpenPhase] = useState(null);

  const togglePhase = (phase) => {
    setOpenPhase(openPhase === phase ? null : phase);
  };

  // *****************


  
const Result = () => {
  return <p className="success-message fw-bold text-success">Your Message has been successfully sent. We will contact you soon.</p>;
};
 const [result, showresult] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [formData, setFormData] = useState({
    fullname: '',
    email: '',
    phone: ''
  });

  const validate = (name, value) => {
    let errors = { ...formErrors };

    switch (name) {
      case 'fullname':
        errors.fullname = !/^[A-Za-z][A-Za-z\s\-]{3,}$/.test(value) ? 'Full Name must be alphabet and at least 3 characters' : '';
        break;
      case 'email':
        errors.email = !/^\S+@\S+\.\S+$/.test(value) ? 'Invalid email address' : '';
        break;
      case 'phone':
        errors.phone = !/^\d{10}$/.test(value) ? 'Phone number must be 10 digits' : '';
        break;
      default:
        break;
    }

    setFormErrors(errors);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleKeyUp = (e) => {
    const { name, value } = e.target;
    validate(name, value);
  };

  const isValid = () => {
    return !Object.values(formErrors).some(error => error) &&
           formData.fullname && formData.email && formData.phone;
  };

  const sendEmail = (e) => {
    e.preventDefault();
    if (!isValid()) {
      alert("Please fix the errors before submitting.");
      return;
    }

    emailjs
      .sendForm('service_kx087j8', 'template_bc3rkxq', e.target, 'EXJNlr7x6Cz38-Sqt')
      .then((result) => {
        console.log(result.text);
      }, (error) => {
        console.log(error.text);
      });

    e.target.reset();
    showresult(true);
    setTimeout(() => showresult(false), 5000);
    setFormData({ fullname: '', email: '', phone: '', subject: '', message: '' });
    setFormErrors({});
  };


// *********************


  return (
    <div>
   

    {/* <!-- pre loader area start --> */}
    {/* <div id="back__preloader">
        <div id="back__circle_loader"></div>
        <div className="back__loader_logo">
            <img loading="lazy"  src="./assets/img/logo/logo-final.png" alt="Preload"/>
        </div>
    </div> */}
    {/* <!-- pre loader area end --> */}

    {/* <!-- Dark/Light area start --> */}
    {/* <div className="mode_switcher my_switcher">
        <button id="light--to-dark-button" className=" align-items-center dark--mode">
            <svg xmlns="http://www.w3.org/2000/svg" className="ionicon dark__mode" viewBox="0 0 512 512"><path d="M160 136c0-30.62 4.51-61.61 16-88C99.57 81.27 48 159.32 48 248c0 119.29 96.71 216 216 216 88.68 0 166.73-51.57 200-128-26.39 11.49-57.38 16-88 16-119.29 0-216-96.71-216-216z" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32"/></svg>

            <svg xmlns="http://www.w3.org/2000/svg" className="ionicon light__mode" viewBox="0 0 512 512"><path fill="none" stroke="currentColor" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="32" d="M256 48v48M256 416v48M403.08 108.92l-33.94 33.94M142.86 369.14l-33.94 33.94M464 256h-48M96 256H48M403.08 403.08l-33.94-33.94M142.86 142.86l-33.94-33.94"/><circle cx="256" cy="256" r="80" fill="none" stroke="currentColor" strokeLinecap="round" strokeMiterlimit="10" strokeWidth="32"/></svg>

            <span className="light__mode">Light</span>
            <span className="dark__mode">Dark</span>
        </button>
    </div> */}
    {/* <!-- Dark/Light area end --> */}

    
        {/* <!-- headar section start --> */}
        <header>
            <div className="headerarea headerarea__2 header__sticky header__area">
                <div className="container desktop__menu__wrapper">
                    <div className="row">
                        <div className="col-xl-2 col-lg-2 col-md-6">
                            <div className="headerarea__left">
                                <div className="headerarea__left__logo">

                                    <a href="/"><img loading="lazy"  src={logo} alt="logo"width="200px" /></a>
                                </div>

                            </div>
                        </div>
                        <div className="col-xl-8 col-lg-8 main_menu_wrap">
                            <div className="headerarea__main__menu">
                                <nav>
                                    <ul>
                                    <li className="mega__menu position-static">
                                    <a className="headerarea__has__dropdown" href="/">Home</a>
                                    </li>
                                    <li className="mega__menu position-static">
                                    <a className="headerarea__has__dropdown" href="/about">About</a>
                                    </li>
                                    <li className="mega__menu position-static">
                                    <a className="headerarea__has__dropdown" href="/why-us">Why Us</a>
                                    </li>


                                        <li className="mega__menu position-static">
                                            <a className="headerarea__has__dropdown" href=" ">Courses  </a>
                                            <div className="headerarea__submenu mega__menu__wrapper">

                                                <div className="row align-items-start">
                                                    <div className="col-4 mega__menu__single__wrap">
                                                        <h3 className="mega__menu__title"><a href="#" className='fs-4' style={{color: '#F4B942'}}>Phase 1</a></h3>
                                                        <ul className="mega__menu__item">
                                                            {/* <li><a href="about.html">About <span className="mega__menu__label">Sale Everything</span></a></li> */}
                                                            {/* <li><a href="about-dark.html">About (Dark)<span className="mega__menu__label new">New</span></a></li> */}
                                                            <li><a href="/foundation">Foundations of Stock Market</a></li>
                                                            <li><a href="/technical-analysis">Technical Analysis</a></li>
                                                            <li><a href="/future-options">Futures & Options</a></li>
                                                           
                                                          
                                                         
                                                        </ul>
                                                    </div>
                                                    <div className="col-4 mega__menu__single__wrap">
                                                        <h4 className="mega__menu__title"><a href="#" className='fs-4'  style={{color: '#F4B942'}}>Phase 2</a></h4>
                                                        <ul className="mega__menu__item">
                                                        <li><a href="/advance-technical-analysis">Advance Technical Analysis</a></li>
                                                            <li><a href="/advance-options-strategies">Advanced Options Strategies</a></li>
                                                            <li><a href="/forex-trading">Forex Trading</a></li>
                                                     
                                                        </ul>
                                                    </div>
                                                 
                                                    
                                                    <div className="col-4 mega__menu__single__wrap sp_top_30">
                                                        <div className="mega__menu__img">
                                                            <a href="#"><img loading="lazy"  src={navimg} alt="Mega Menu"/></a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </li> 

                                        <li className="mega__menu position-static">
                                    <a className="headerarea__has__dropdown" href="/gallery">Gallery</a>
                                    </li>

                                        <li className="mega__menu position-static">
                                    <a className="headerarea__has__dropdown" href="/contact">Contact Us</a>
                                    </li>


                                    </ul>
                                </nav>
                            </div>
                        </div>
                        <div className="col-xl-2 col-lg-2 col-md-6">
                            <div className="headerarea__right">
                                <div className="headerarea__button">
                                    {/* <a href="">Free Demo</a> */}
                                    <a onClick={openPopup} style={{cursor: 'pointer',borderRadius:'50px',padding:'10px 20px'}} className='free-demo-btn '>Free Demo</a>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>


   {/* Pop-up Form */}
   <div className={`popup-form ${isOpen ? 'open' : ''}`}>
        <div className="popup-content">
          <div className="popup-header">
            <h2>Free Demo</h2>
            <button className="close-btn" onClick={closePopup}> x </button>
          </div>
          <form onSubmit={sendEmail}>
            {/* <label for="fullName">Full Name</label> */}
            <input type="text" id="fullName" name="fullname" required placeholder='Enter Your Name' 
            onKeyUp={handleKeyUp}
            onChange={handleChange} className='text-black'
            />
  {formErrors.fullname && <small style={{ color: 'red' }}>{formErrors.fullname}</small>}
            {/* <label for="email">Email</label> */}
            <input type="email" id="email" name="email" required placeholder='Enter Your Email ID'
              onKeyUp={handleKeyUp}
              onChange={handleChange}  className='text-black'/>
              {formErrors.email && <small style={{ color: 'red' }}>{formErrors.email}</small>}

            {/* <label for="phone">Phone Number</label> */}
            <input type="tel" id="phone" name="phone" required placeholder='Enter Your Mobile Number' 
              onKeyUp={handleKeyUp}
              onChange={handleChange} className='text-black'/>
               {formErrors.phone && <small style={{ color: 'red' }}>{formErrors.phone}</small>}

            {/* <label for="referal-code">Referal code</label> */}
            <input type="text" id="referal-code" name="referal-code" placeholder='Referal Code (optional)' 
             className='text-black'/>
            

            <button type="submit" className='mt-2'>Submit</button>
          </form>
          <div className="form-group">
                  {result ? <Result /> : null}
                </div>

        </div>
      </div>

{/* **************************** */}


<div className="container mob_menu_wrapper">
        <div className="row align-items-center">
          <div className="col-6">
            <div className="mobile-logo">
              <a className="logo__dark" href="#">
                <img src={logo} alt="logo" />
              </a>
            </div>
          </div>
          <div className="col-6 text-end">
            {/* <button
              className="mobile-aside-button"
              onClick={() => setMenuOpen(!menuOpen)}
              style={{ backgroundColor: 'none', border: 'none' }}
            /> */}

<button
              onClick={() => setMenuOpen(!menuOpen)}
              style={{ background: 'none', border: 'none', fontSize: '24px', color: '#fff' }}
            >
              <FaBars />
            </button>
              {/* <i className="icofont-navigation-menu"  style={{ fontSize: '26px', color: '#fff' }}></i> */}
          
        
          </div>
        </div>
      </div>

      <div className="">
        {/* <a className="mobile-aside-close" onClick={() => setMenuOpen(false)}>
          <FaTimes />
        </a> */}

        {/* Your menu content goes here */}
      </div>

            </div>
        </header>
        {/* <!-- header section end --> */}


   {/* <!-- Mobile Menu Start Here --> */}
<div className={`mobile-off-canvas-active ${menuOpen ? "inside" : ""}`}>
        <a className="mobile-aside-close" onClick={() => setMenuOpen(false)}>
   
    <FaTimes/>
  </a>
            <div className="header-mobile-aside-wrap">
                
                <div className="mobile-menu-wrap headerarea">
        
                    <div className="mobile-navigation">
        
                        <nav>
                            <ul className="mobile-menu">
                                <li className=""><a href="/">Home</a> </li>
        
                                <li className=""><a href="/about">About</a> </li>

                                <li className=""><a href="/why-us">Why Us</a> </li>
                              
    

        

{/* ************************************ */}

<li className="menu-item menu-item-has-children">
      <a href="#" onClick={(e) => e.preventDefault()}>
        Courses &nbsp; <FaChevronDown/>
      </a>

      <ul className="dropdown">
        {/* Phase 1 */}
        <li className={`menu-item menu-item-has-children ${openPhase === 'phase1' ? 'open' : ''}`} style={{backgroundColor:'#111111'}} >
          <a href="#" onClick={(e) => { e.preventDefault(); togglePhase('phase1'); }}style={{color:'white',backgroundColor:'#111111'}} >
            Phase 1  &nbsp; <FaChevronDown/>  <span className="menu-expand">&#9656;</span>
          </a>
          <ul className="dropdown">
            <li style={{backgroundColor:'#111111'}}><a href="/foundation"style={{color:'white',backgroundColor:'#111111'}}>Foundations of Stock Market</a></li>
            <li style={{backgroundColor:'#111111'}}><a href="/technical-analysis" style={{color:'white',backgroundColor:'#111111'}}>Technical Analysis</a></li>
            <li style={{backgroundColor:'#111111'}}><a href="/future-options" style={{color:'white',backgroundColor:'#111111'}}>Futures & Options</a></li>
          </ul>
        </li>

        {/* Phase 2 */}
        <li className={`menu-item menu-item-has-children ${openPhase === 'phase2' ? 'open' : ''}`} style={{backgroundColor:'#111111'}}>
          <a href="#" onClick={(e) => { e.preventDefault(); togglePhase('phase2'); }} style={{color:'white',backgroundColor:'#111111'}}>
            Phase 2  &nbsp; <FaChevronDown/> <span className="menu-expand">&#9656;</span>
          </a>
          <ul className="dropdown">
            <li style={{backgroundColor:'#111111'}}><a href="/advance-technical-analysis" style={{color:'white',backgroundColor:'#111111'}}>Advance Technical Analysis</a></li>
            <li style={{backgroundColor:'#111111'}}><a href="/advance-options-strategies" style={{color:'white',backgroundColor:'#111111'}}>Advanced Options Strategies</a></li>
            <li style={{backgroundColor:'#111111'}}><a href="/forex-trading" style={{color:'white',backgroundColor:'#111111'}}>Forex Trading</a></li>
          </ul>
        </li>
      </ul>
    </li>



{/* ************************************* */}

    <li className=""><a href="/gallery">Gallery</a> </li>

<li className=""><a href="/contact">Contact Us</a> </li>
 
    <li><a onClick={openPopup} style={{cursor: 'pointer',borderRadius:'50px',padding:'10px 20px'}} className='free-demo-btn'>Free Demo</a></li>

                                </ul>
                        </nav>
        
                    </div>
        
                </div>
              
                <div className="mobile-social-wrap">
                    <a className="facebook" href="https://www.facebook.com/profile.php?id=61575582539320" target='_blank'><FaFacebook /></a>
                    <a className="instagram" href="https://www.instagram.com/trading_whaless/" target='_blank'><FaInstagram/> </a>
                  
                    <a className="instagram" href="https://www.youtube.com/channel/UC6YiqBS4VC3Xl9N4ruVVjvg" target='_blank'> <FaYoutube/> </a>
                    
                </div>
            </div>
        </div>
        {/* <!-- Mobile Menu end Here --> */}

        {/* <!-- theme fixed shadow --> */}
        <div>
            <div className="theme__shadow__circle"></div>
            <div className="theme__shadow__circle shadow__right"></div>
        </div>
        {/* <!-- theme fixed shadow --> */}

{/* </main> */}

    </div>
    
  
  )
}

export default Header
